import { gql } from '@apollo/client';

import { JOB_POSITION_FOR_LIST_FRAGMENT } from './job-position-for-list';

export const JOB_POSITION_FOR_CANDIDATE_FRAGMENT = gql`
  fragment JobPositionForCandidate on JobPositionForCandidateDto {
    distance
    id
    jobPosition {
      ...JobPositionForList
    }
    match {
      connectionStatus
      connectionType
      id
      invitationText
    }
    newPosition
  }
  ${JOB_POSITION_FOR_LIST_FRAGMENT}
`;
